import React from "react";
import logoBackground from 'assets/media/img/login-bg.jpg';
import logoLightVertical from 'assets/media/brands/logo-light-vertical.svg';
import "./styles.less";
import Loading from "app/components/Loading/Loading";

interface GuestLayoutProps {
	children: React.ReactNode;
}

const GuestLayout: React.FC<GuestLayoutProps> = (props: any) => {
	return (
		<>
			<div className="d-flex flex-column flex-root">
				{/* <!--begin::Login--> */}
				<div
					className="login login-6 login-signin-on login-signin-on d-flex flex-row-fluid"
					id="kt_login"
				>
					<div className="d-flex flex-column flex-lg-row flex-row-fluid">
						{/* <!--begin:Aside--> */}
						<div className="d-flex w-50 flex-center login-left">
							<div
								className="login-background"
								style={{
									backgroundImage:
										"url(" + logoBackground + ")",
								}}
							>
								<div className="login-bg-logo">
									<img alt="" src={logoLightVertical} width="180" />
								</div>
							</div>
						</div>
						{/* <!--end:Aside-->
        <!--begin:Content--> */}
						{props.children}
						{/* <!--end:Content--> */}
					</div>
				</div>
				{/* <!--end::Login--> */}
			</div>
		</>
	);
};
export default GuestLayout;
